import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCIntroPixComponent = class UiCIntroPixComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCIntroPixComponent.prototype, "urlImg", void 0);
UiCIntroPixComponent = __decorate([
    Component({
        selector: 'ui-c-intro-pix',
        template: "<ion-row class=\"ion-justify-content-center ion-align-items-center\">\n  <ion-col size=\"7\">\n    <ion-img class=\"ion-margin-bottom\" [src]=\"urlImg\">\n    </ion-img>\n  </ion-col>\n</ion-row>\n\n<ion-text class=\"ion-text-center\">\n  <p class=\"font-family-bold ion-margin margin-bottom-and-top-30\">\n    {{'PIX.INTRO_PIX.FIRST_DESCRIPTION' | wlpTranslate}}</p>\n</ion-text>\n\n<ion-text class=\"ion-text-center\">\n  <p class=\"ion-margin margin-bottom-and-top-30\">{{'PIX.INTRO_PIX.SECOND_DESCRIPTION' | wlpTranslate}}</p>\n</ion-text>\n\n<ion-text class=\"ion-text-center\">\n  <p class=\"ion-margin margin-bottom-and-top-30\">{{'PIX.INTRO_PIX.THIRD_DESCRIPTION' | wlpTranslate}}</p>\n</ion-text>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCIntroPixComponent);

let UiCIntroPixModule = class UiCIntroPixModule {
};
UiCIntroPixModule = __decorate([
    NgModule({
        declarations: [
            UiCIntroPixComponent
        ],
        imports: [
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [
            UiCIntroPixComponent
        ]
    })
], UiCIntroPixModule);

export { UiCIntroPixComponent, UiCIntroPixModule };
//# sourceMappingURL=wlp-ui-c-intro-pix.js.map
